import { render, staticRenderFns } from "./CardapioUnidadeEscolar.vue?vue&type=template&id=66666b0f&scoped=true&"
import script from "./CardapioUnidadeEscolar.vue?vue&type=script&lang=js&"
export * from "./CardapioUnidadeEscolar.vue?vue&type=script&lang=js&"
import style0 from "./CardapioUnidadeEscolar.vue?vue&type=style&index=0&id=66666b0f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66666b0f",
  null
  
)

export default component.exports